import { render, staticRenderFns } from "./InputPriceCard.vue?vue&type=template&id=3028a482&scoped=true"
import script from "./InputPriceCard.vue?vue&type=script&lang=js"
export * from "./InputPriceCard.vue?vue&type=script&lang=js"
import style0 from "./InputPriceCard.vue?vue&type=style&index=0&id=3028a482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028a482",
  null
  
)

export default component.exports